var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "normal-goc",
      on: {
        click: function($event) {
          return _vm.selectGOC()
        }
      }
    },
    [
      _c("div", { staticClass: "floating-price" }, [
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/price_shape.svg?v=1720452978"
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm._f("moneyFloatFormat")(_vm.goc)))])
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", [_vm._m(0)])
        : _c(
            "div",
            { staticClass: "flicking-container" },
            [
              _c("img", {
                staticClass: "right-arrow lazyload",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/right_arrow.svg?v=1719422956"
                },
                on: {
                  click: [
                    function($event) {
                      $event.stopPropagation()
                    },
                    function($event) {
                      return _vm.nextSlide()
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "left-arrow lazyload",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/left_arrow.svg?v=1719422955"
                },
                on: {
                  click: [
                    function($event) {
                      $event.stopPropagation()
                    },
                    function($event) {
                      return _vm.prevSlide()
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "Flicking",
                {
                  ref: "flicking",
                  attrs: {
                    options: {
                      align: "prev",
                      circular: true,
                      preventDefaultOnDrag: true,
                      preventClickOnDrag: true,
                      renderOnlyVisible: true
                    }
                  }
                },
                _vm._l(_vm.productImages, function(image) {
                  return _c("div", { staticClass: "panel" }, [
                    _c("img", {
                      staticClass: "lazyload flicker-image",
                      attrs: { src: image }
                    })
                  ])
                }),
                0
              )
            ],
            1
          ),
      _vm._v(" "),
      _c("p", { staticClass: "happybox-button white border" }, [
        _vm._v(
          "View " + _vm._s(_vm._f("moneyFloatFormat")(_vm.goc)) + " Collection"
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spinner-container" }, [
      _c("div", { staticClass: "spinner" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }